import { render, staticRenderFns } from "./SendOrderShopee.vue?vue&type=template&id=c354105a&scoped=true"
import script from "./SendOrderShopee.vue?vue&type=script&lang=js"
export * from "./SendOrderShopee.vue?vue&type=script&lang=js"
import style0 from "./SendOrderShopee.vue?vue&type=style&index=0&id=c354105a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c354105a",
  null
  
)

export default component.exports